'use strict';


import { BaseElement } from '../interfaces/BaseElement';
import { Range } from '../interfaces/switchers/Range';
import { MathUtils, Vector3 } from 'three';
import { autoRotateTimerAction } from './orbitControls';
import { assignDeep } from '../../settings';


const DEFAULT_PARAMS = {
	active: false
};

export class SkyLineController {
	constructor (orbitControls) {
		this.params = assignDeep(DEFAULT_PARAMS,config.features.skyLineController || {});
		this.orbitControls = orbitControls;
		this.camera = this.orbitControls.object;
		this.step = 0.001;
		this.direction = new Vector3();
		this.targetStart = new Vector3();
		this.targetEnd = new Vector3();
	}
	
	ui(parent) {
		if (!this.params.active)
			return;
		this.uiElement = new BaseElement()
			.addClass('skyline')
			.event('pointerenter',this.onEnter.bind(this))
			.event('pointerleave',this.onLeave.bind(this))
			.appendTo(parent)
			.DOMElement;
		
		const wrapper = new BaseElement()
			.addClass('skyline__wrapper')
			.appendTo(this.uiElement)
			.DOMElement;
		
		const min = this.orbitControls.maxSphere ? this.orbitControls.maxSphere.center.y : this.orbitControls.minPan.y;
		const max = this.orbitControls.maxSphere ? this.orbitControls.maxSphere.radius : this.orbitControls.maxPan.y;
		this.targetStart.set(
			0,
			min,
			0
		);
		this.targetEnd.set(
			0,
			max,
			0
		);
		
		const value = (MathUtils.clamp(this.orbitControls.target.y - min,min,max)) / (max - min);
		
		const range = new Range(wrapper,0,1,this.step,value);
		range.addListener('input',this.onMove.bind(this));
		range.addListener('mousedown',this.onStart.bind(this));
		range.addListener('touchstart',this.onStart.bind(this));
		range.addListener('change',this.onEnd.bind(this));
		range.vertical();
		
		const icons = new BaseElement()
			.addClass('skyline__icons')
			.appendTo(wrapper)
			.DOMElement;
		
		['up','down'].forEach(direction => {
			const icon = new BaseElement()
				.addClass('skyline__icon',`skyline__icon--${direction}`)
				.appendTo(icons)
				.DOMElement;
			
			new BaseElement()
				.addClass('skyline__icon-image','icon-open')
				.appendTo(icon);
			
			new BaseElement()
				.addClass('skyline__icon-direction',`icon-${direction}`)
				.appendTo(icon)
		});
	}
	
	onEnter() {
		this.uiElement.classList.add('skyline--hover');
	}
	
	onLeave() {
		this.uiElement.classList.remove('skyline--hover');
	}
	
	onStart() {
		this.orbitControls.screenSpacePanning = true;
		autoRotateTimerAction('update');
	}
	
	onMove(e) {
		const value = Number(e.target.value);
		this.direction.copy(this.camera.position).sub(this.orbitControls.target);
		this.orbitControls.target.lerpVectors(this.targetStart,this.targetEnd,value);
		this.camera.position.copy(this.orbitControls.target).add(this.direction);
	}
	
	onEnd() {
		autoRotateTimerAction('update');
		this.orbitControls.screenSpacePanning = false;
	}
	
}
